import React, { Component } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { get as _get } from "lodash";

import { withRouter } from "../../resusableComponents/hoc/withRouter";
import { applicationRoutes } from "./../../helpers/constants";

import ViewCompetitiveAnalysisReport from "../CompetitiveAnalysis/ViewCompetitiveAnalysisReport";
import PBICampaignDashboard from "../CampaignDashboard/PBICampaignDashboard";
import UnderConstruction from "../CommonPages/UnderConstruction";
import ViewDeepResearchReport from "../ViewDeepResearchReport";
import CampaignDataHistory from "../CampaignDataHistory";
import CompetitiveAnalysis from "../CompetitiveAnalysis";
import ClientTemplates from "../Admin/ClientTemplates";
import UserManagement from "../Admin/UserManagement";
import CampaignDashboard from "../CampaignDashboard";
import AgencyDashboard from "../AgencyDashboard";
import CampaignContent from "../CampaignContent";
import ClientAnalysis from "../ClientAnalysis";
import CampaignSetup from "../CampaignSetup";
import CampaignList from "../CampaignList";
import CampaignEdit from "../CampaignEdit";
import Sidebar from "./components/Sidebar";
import CompanyCard from "../CompanyCard";
import Header from "./components/Header";
import UploadLead from "../UploadLead";
import Dashboard from "../Dashboard";
import ViewLeads from "../ViewLeads";
import Settings from "../Settings";

const resusableComponents = {
  viewCompetitiveAnalysisReport: ViewCompetitiveAnalysisReport,
  viewDeepResearchReport: ViewDeepResearchReport,
  PBICampaignDashboard: PBICampaignDashboard,
  competitiveAnalysis: CompetitiveAnalysis,
  underConstruction: UnderConstruction,
  campaignDashboard: CampaignDashboard,
  campaignHistory: CampaignDataHistory,
  clientTemplates: ClientTemplates,
  agencyDashboard: AgencyDashboard,
  campaignContent: CampaignContent,
  clientAnalysis: ClientAnalysis,
  userManagement: UserManagement,
  campaignSetup: CampaignSetup,
  campaignList: CampaignList,
  campaignEdit: CampaignEdit,
  companyCard: CompanyCard,
  uploadLead: UploadLead,
  viewLeads: ViewLeads,
  dashboard: Dashboard,
  settings: Settings
}

class Application extends Component {

  render() {
    const { isNavbarVisible } = this.props;

    return (
      <React.Fragment>
        <div className="layout-wrapper layout-content-navbar">
          <div className="layout-container">
            <Sidebar />
            <div className={`layout-page ${(isNavbarVisible === true) ? "" : "active"}`}>
              <Header />
              <div className="content-wrapper">
                <Routes>
                  {
                    applicationRoutes.map(({ component, ...rest }, key) => {

                      const RouteComponent = (resusableComponents[component] || "");

                      if (typeof RouteComponent !== "undefined" && RouteComponent !== "") {
                        return <Route key={key} {...rest} element={<RouteComponent />} />
                      } else {
                        return null;
                      }
                    })
                  }
                  <Route path="*" element={<Navigate from="*" to="/" replace />} />
                </Routes>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, props) => ({
  isNavbarVisible: _get(state, "application.isNavbarVisible", false)
});

export default withRouter(connect(mapStateToProps, null)(injectIntl(Application)));
